import { ICreateProgramItemActionPayload } from '../interfaces/create-program-item.action.payload.interface';

export class ProgramItemCommand {
    name: string;
    category: {
        id: number;
    };
    type: string;
    section: boolean;
    section_rule: string;
    self_paced: boolean;
    offering_group: {
        id: number;
    };
    tags: { id: string }[];
    managers: { id: string }[];

    constructor(tempTap: ICreateProgramItemActionPayload) {
        this.name = tempTap.name;
        this.category = { id: Number(tempTap.category.id) };
        this.type = tempTap.type;
        this.section = tempTap.section;
        this.section_rule = tempTap.sectionRule;
        this.self_paced = tempTap.selfPaced;
        this.offering_group = tempTap.offeringGroup.id ? { id: Number(tempTap.offeringGroup.id) } : null;
        this.tags = tempTap.tags.map((tag) => ({ id: tag.id }));
        this.managers = tempTap.managers.length ? tempTap.managers.map((tag) => ({ id: tag.id })) : null;
    }
}
